export const API_URL = process.env.REACT_APP_API_URL as string;
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL as string;
export const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;
export const APP_ENV = process.env.REACT_APP_ENV as string;

export const LANGUAGES = [
  { label: "Serbian", code: "rs" },
  { label: "English", code: "en" },
];
